<template>
  <div class="upload">
    <div class="upload__title">{{title}}:</div>
    <div class="upload__custom">
      <label class="upload__label" :for="labelFor">SEÇ</label>
      <label class="upload__label -secondary" :for="labelFor">Dosya Seçiniz</label>
      <input
        :id="labelFor"
        class="upload__input"
        type="file"
        :accept="fileType"
        name="file"
        @change="filesChange($event.target.name, $event.target.files)"
        ref="uploadFileInput"
      />
      <div v-if="isloading" class="upload__loading"></div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";

export default {
  props: {
    title: {
      type: String,
      value: null,
    },
    fileType: {
      type: String,
      value: null,
    },
    labelFor: {
      type: String,
      value: null,
    }
  },
  data() {
    return {
      isloading: false,
    };
  },
  methods: {
    filesChange: async function (fieldName, fileList) {
      let vm = this;

      vm.isloading = true;

      const formData = new FormData();

      if (!fileList.length) return;

      Array.from(Array(fileList.length).keys()).map((obj) => {
        formData.append(fieldName, fileList[obj], fileList[obj].name);
      });

      await API.createMedia(formData).then((response) => {
        vm.$emit("input", response.result.file);
      });

      vm.isloading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  margin-bottom: 24px;

  &__title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.37px;
    color: var(--teal-blue);

    color: var(--form-input-label);

    font-size: 16px;
    font-weight: 500;

    letter-spacing: 0.37px;
  }

  &__input {
    display: none;
  }

  &__custom {
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 0 10px;

    width: 100%;
    max-width: 410px;

    height: 60px;

    background-color: var(--form-background);

    border-radius: 8px;
    border: none;

    box-shadow: 0 10px 20px 0 var(--form-input-shadow);

    outline: none;
  }

  &__label {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 65px;
    height: 40px;

    color: var(--color-denim);

    font-size: 14px;
    font-weight: 500;

    border-radius: 4px;

    background-color: var(--color-light-blue-grey);

    letter-spacing: 0.32px;

    cursor: pointer;

    &.-secondary {
      margin: 0 0 0 20px;

      width: auto;
      height: auto;

      color: var(--color-bluish);

      font-size: 18px;
      font-weight: 400;

      background-color: transparent;

      letter-spacing: 0.42px;
    }
  }

  &__loading {
    display: inline-block;
    width: 36px;
    height: 36px;

    &:after {
      content: " ";

      margin: 0 0 0 8px;

      display: block;

      width: 24px;
      height: 24px;

      border-radius: 50%;
      border: 2px solid var(--button-color);
      border-color: var(--button-color) transparent var(--button-color)
        transparent;

      animation: loading 1.2s linear infinite;
    }

    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>